import Discord from "../../api/userInfo";
import Tippy from "@tippyjs/react";
import "tippy.js/animations/scale.css";
import "tippy.js/dist/tippy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGithub, faDiscord, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const socialButtonStyle =
    "group rounded-full bg-white dark:bg-slate-800/50 border border-slate-300 dark:border-slate-700/50 size-[36px] items-center flex justify-center text-slate-700 dark:text-slate-400 hover:scale-110 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md hover:border-slate-400 dark:hover:border-slate-500 hover:bg-slate-50 dark:hover:bg-slate-700 text-sm";

  return (
    <div className="relative z-30 p-3 sm:p-4 rounded-xl shadow-md text-neutral-800 dark:text-neutral-200 bg-white/40 dark:bg-slate-900/60 backdrop-blur-xl border border-white/20 dark:border-slate-800/50 transition-colors duration-300">
      <Discord />
      <div className="flex mt-3.5 gap-2 text-base justify-center md:justify-start flex-wrap">
        <Tippy animation="scale" content="Gmail">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="mailto:hienleeone@gmail.com"
          >
            <FontAwesomeIcon icon={faEnvelope} className="group-hover:text-red-500 transition-colors" />
          </a>
        </Tippy>

        <Tippy animation="scale" content="Github">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="https://github.com/hienleeone"
          >
            <FontAwesomeIcon icon={faGithub} className="group-hover:text-slate-900 dark:group-hover:text-white transition-colors" />
          </a>
        </Tippy>

        <Tippy animation="scale" content="Discord">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="https://discord.com/users/655981892193091594"
          >
            <FontAwesomeIcon icon={faDiscord} className="group-hover:text-[#5865F2] transition-colors" />
          </a>
        </Tippy>

        <Tippy animation="scale" content="Facebook">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="https://facebook.com/hienleeone"
          >
            <FontAwesomeIcon icon={faFacebook} className="group-hover:text-[#1877F2] transition-colors" />
          </a>
        </Tippy>

        <Tippy animation="scale" content="TikTok">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="https://www.tiktok.com/@hienleeone"
          >
            <FontAwesomeIcon icon={faTiktok} className="group-hover:text-[#FE2C55] transition-colors" />
          </a>
        </Tippy>

        <Tippy animation="scale" content="Zalo/SĐT">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className={socialButtonStyle}
            href="https://zalo.me/0328505423"
          >
            <div
              className="w-5 h-5 bg-slate-700 dark:bg-slate-400 group-hover:bg-[#0068FF] transition-all"
              style={{
                maskImage: 'url(https://api.iconify.design/simple-icons:zalo.svg)',
                WebkitMaskImage: 'url(https://api.iconify.design/simple-icons:zalo.svg)',
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center'
              }}
            />
          </a>
        </Tippy>
      </div>
    </div>
  );
}

export default Header;
